import { Accordion, Grid, GridContainer } from "@trussworks/react-uswds";
import { Marker } from "react-leaflet";
import {
  //Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

import { ReactComponent as Ages } from "../images/ages.svg";
import { ReactComponent as Populations } from "../images/populations.svg";
import { ReactComponent as Accessibility } from "../images/accessibility.svg";
import { ReactComponent as Languages } from "../images/languages.svg";
import Map from "../components/Map";
import BasicResultDetail from "../components/ResultDetail/BasicResultDetail";
import BulletedList from "../components/BulletedList";
import { Fragment, useEffect, useState } from "react";
import DirectionsLink from "../components/ResultDetail/DirectionsLink";
import ShareButton from "../components/ShareButton";
import { logPageView } from "../utils/analytics";
import BackButton from "../components/BackButton";
import ProviderUpdateInfo from "../components/ResultDetail/ProviderUpdateInfo";
import CallProviderLink from "../components/ResultDetail/CallProviderLink";
import TelehealthOnlyMap from "../components/TelehealthOnlyMap";

import PrintButton from "../components/PrintButton";
// import Spinner from "../components/Spinner";
import { V1Clinic, ClinicLocation } from "../types/v1_schemas";
import { QuerySingleApi } from "../utils/QueryHelper";
import { AxiosResponse } from "axios";
import { handlePageLoad } from "../utils/accessibility";
import { getMapMarker } from "../utils/map";


const ResultDetail = () => {
  console.log(">>>>>> IN RESULTDetails.ts.x >>>>>");
  const { t, i18n } = useTranslation();
  const location = useLocation();
  // If user navigated from /search results page, they have sent the entity-specific
  // data and the url search params as `prevSearch`
  let { prevSearch } = (location.state ?? {}) as {
    prevSearch?: string;
  };

  const params = useParams();
  const [data, setData] = useState<V1Clinic>();

  // const LinkButton: CSSProperties = {
  //   backgroundColor: "transparent",
  //   color:"#2f6fa7",
  //   border: "none",
  //   cursor: "pointer",
  //   textDecoration: "underline",
  //   display: "inline",
  //   margin: "0",
  //   padding: "0"
  // };
  

  const responseFn = (response: AxiosResponse) => {
    if (response.status === 200) {
      setData(response.data ? (response.data as V1Clinic) : undefined);
    } else {
      console.error(`Result Detail: HTTP error! Status: ${response.status}`);
    }
  };

  const errorFn = (error: any) => {
    console.error(`Result Detail: Axios Error: ${error.message}`);
  };

  useEffect(() => {
    QuerySingleApi(
      params.resultId ?? "",
      i18n.language,
      new AbortController().signal,
      responseFn,
      errorFn
    );
  }, [params, i18n.language]);

  const ClinicLocation = data?.clinicLocations?.find(
    (element: ClinicLocation) => {
      return element.latitude?.length && element.longitude?.length;
    }
  );

  let position = undefined;

  if (
    ClinicLocation &&
    ClinicLocation.latitude?.length &&
    ClinicLocation.longitude?.length
  ) {
    let lat = +ClinicLocation.latitude;
    console.log(`lat is ${lat}`);
    let lng = +ClinicLocation.longitude;
    console.log(`lng is ${lng}`);
    position = { lat: lat, lng: lng };
  }

  let address = undefined;

  if (
    ClinicLocation &&
    ClinicLocation.addressLine1?.length &&
    ClinicLocation.cityText?.length &&
    ClinicLocation.postalCode?.length
  ) {
    address = [
      ClinicLocation.addressLine1,
      ClinicLocation.cityText + ", CO " + ClinicLocation.postalCode,
    ];
  }

  let servicesProvided: { [serviceCategory: string]: string[] } = {};

  data?.clinicServicesProvideds?.forEach(function (value) {
    if (value?.serviceCategoryText && value?.serviceProvidedText) {
      if (!servicesProvided[value.serviceCategoryText]) {
        servicesProvided[value.serviceCategoryText] = [];
      }
      servicesProvided[value.serviceCategoryText].push(
        value.serviceProvidedDescription ?? ""
      );
    }
  });

  data?.clinicSSServicesProvideds?.forEach(function (value) {
    if (value?.ssserviceProvidedText && value.ssserviceProvidedText !== t("psychedelicTreatment")) {
      if (!servicesProvided[t("typeOfHelpShortValuesmental_health")]) {
        servicesProvided[t("typeOfHelpShortValuesmental_health")] = [];
      }
      servicesProvided[t("typeOfHelpShortValuesmental_health")].push(
        value.ssserviceProvidedDescription ?? ""
      );
    }
  });
  
  let categories = Object.keys(servicesProvided);
  if (categories.indexOf(t("typeOfHelpShortValuessubstance_use")) < 0) { servicesProvided[t("typeOfHelpShortValuessubstance_use")] = []; }
  if (categories.indexOf(t("typeOfHelpShortValuesmental_health")) < 0) { servicesProvided[t("typeOfHelpShortValuesmental_health")] = [t("moreInfo")]; }
  if (categories.indexOf(t("typeOfHelpShortValuesDUI_DWAI")) >= 0) servicesProvided[t("typeOfHelpShortValuesDUI_DWAI")].forEach((x) => {
    servicesProvided[t("typeOfHelpShortValuessubstance_use")].push(x);
  })
  delete servicesProvided[t("typeOfHelpShortValuesDUI_DWAI")];
  if (categories.indexOf(t("typeOfHelpShortValuesopioid_use")) >= 0) servicesProvided[t("typeOfHelpShortValuesopioid_use")].forEach((x) => {
    servicesProvided[t("typeOfHelpShortValuessubstance_use")].push(x);
  })
  delete servicesProvided[t("typeOfHelpShortValuesopioid_use")];

  function SortCategories(a: string, b: string){
    const mentalHealth = t("typeOfHelpShortValuesmental_health"), substanceUse = t("typeOfHelpShortValuessubstance_use");
    if (a === mentalHealth) 
      return -1;

    if (a === substanceUse) 
      if (b === mentalHealth) 
        return 1;
      else return -1;

    return 1;
  }

  const renderServicesProvided = () => {
    return Object.keys(servicesProvided)
      .sort((a, b) => SortCategories(a, b))
      .map((value) => {
        return (
          <div className="body_font dark_blue">
            <div className="display-flex flex-align-center margin-bottom-05 body_font dark_blue">
              <h3 className="margin-0 body_font dark_blue"  style={{"fontFamily":"Trebuchet MS"}} >
                <span className="body_font dark_blue">{value}</span></h3>
            </div>
            <BulletedList
              values={[...new Set(servicesProvided[value])].sort()}// conversion to Set and back removes duplicates
              className="line-height-body-4"
              emptyMsg={t("moreInfo")}
            />
          </div>
        );
      });
  };

  let agesGenderIdentities: string[] = [];

  data?.clinicPatientAgeGroups?.forEach(function (value) {
    if (value?.patientAgeGroupText?.length) {
      agesGenderIdentities.push(value.patientAgeGroupText);
    }
  });

  data?.clinicPatientGenders?.forEach(function (value) {
    if (value?.patientGenderText?.length) {
      agesGenderIdentities.push(value.patientGenderText);
    }
  });

  let populationsServed: string[] = [];

  data?.clinicCommunityServeds?.forEach(function (value) {
    if (value?.lineageText?.toLowerCase() === "adults") return; // per bug 228741, comment from Jumana on 9/5/24 1:52 pm

    if (value?.patientCommunityText?.length) {
      if (value.patientCommunityText.toLowerCase() === "other")
        value.patientCommunityText = "More communities";
      if (value.patientCommunityText.toLowerCase() === "otro")
        value.patientCommunityText = "Más comunidades";
      if (value.patientCommunityWriteIn?.length) {
        populationsServed.push(
          value.patientCommunityText + ": " + value.patientCommunityWriteIn
        );
      } else populationsServed.push(value.patientCommunityText);
    }
  });
  data?.clinicPatientEthnicities?.forEach(function (value) {
    if (value?.lineageText?.toLowerCase() === "adults") return; // per bug 228741, comment from Jumana on 9/5/24 1:52 pm

    if (value?.patientEthnicityText?.length) {
      if (value.patientEthnicityText.toLowerCase() === "other")
        value.patientEthnicityText = "More communities";
      if (value.patientEthnicityText.toLowerCase() === "otro")
        value.patientEthnicityText = "Más comunidades";
      if (value.patientEthnicityWriteIn?.length) {
        populationsServed.push(
          value.patientEthnicityText + ": " + value.patientEthnicityWriteIn
        );
      } else populationsServed.push(value.patientEthnicityText);
    }
  });

  let languages: string[] = [];

  data?.clinicLanguageUseds?.forEach(function (value) {
    if (value?.languageText?.length) {
      if (value.languageText.toLowerCase() === "other")
        value.languageText = "More languages";
      if (value.languageText.toLowerCase() === "otro")
        value.languageText = "Más idiomas";
      if (value.languageWriteIn?.length) {
        languages.push(value.languageText + ": " + value.languageWriteIn);
      } else languages.push(value.languageText);
    }
  });

  let accessibility: string[] = [];

  data?.clinicAccessibilityOffereds?.forEach(function (value) {
    if (value?.accessibilitySupportText?.length) {
      if (value.accessibilitySupportText.toLowerCase() === "other")
        value.accessibilitySupportText = "More accessibility access";
      if (value.accessibilitySupportText.toLowerCase() === "otro")
        value.accessibilitySupportText = "Más acceso a la accesibilidad";
      if (value.accessibilitySupportWriteIn?.length) {
        accessibility.push(
          value.accessibilitySupportText +
            ": " +
            value.accessibilitySupportWriteIn
        );
      } else accessibility.push(value.accessibilitySupportText);
    }
  });

  useEffect(() => {
    logPageView();
    handlePageLoad();
    // eslint-disable-next-line
  }, [params]);

  return (
    <Fragment>
      <GridContainer className="ResultDetail">
        <div className="margin-y-2 display-flex flex-justify">
          <BackButton 
            text={t("backToSearch")}
            href={`/search${prevSearch ?? ""}`}
          />
          <div className="display-flex flex-align-center">
            <PrintButton className="margin-right-3" />
            <ShareButton text={t("detailsPageShare")} />
          </div>
        </div>
        <Grid row className="flex-justify flex-align-baseline margin-bottom-2" >
          <h1 className="margin-top-2 margin-bottom-0 text-focus-no-outline nice_font dark_blue">{data?.displayName}</h1>
        </Grid>
        <section>
          <h2 className="usa-sr-only">Basic info</h2>
          <Grid row>
            <Grid
              tablet={{ col: 6 }}
              className="padding-0 tablet:padding-x-1 order-last order-md-first"
            >
            <BasicResultDetail result={data} />
            </Grid>
            <Grid tablet={{ col: true }}>
            <div className="display-grid">
                {position && address ? (
                  <Map
                    mapContainerProps={{
                      center: position,
                      zoom: 14,
                      dragging: isMobile ? false : true,
                    }}
                    mapContainerStyles={{
                      flex: 1,
                      height: "250px",
                      borderRadius: "10px",
                    }}
                  >
                    <Marker
                      icon={getMapMarker(data)}
                      position={position}
                      interactive={false}
                      keyboard={false}
                    />
                  </Map>
                ) : (
                  <TelehealthOnlyMap
                    alertMessage={t("telehealthMapAlert")}
                    mapContainerStyles={{ borderRadius: "10px" }}
                  />
                )}

                <div className="margin-y-2 body_font" style={{borderRadius:'5px', backgroundColor:'#F7F8F8',outline:'2px #B2D236 solid', outlineOffset:'-1px'}}>
                  {position && address ? (
                    <DirectionsLink v1Clinic={data} />
                  ) : (
                    <CallProviderLink v1Clinic={data} />
                  )}
                </div>

                {data?.clinicTelehealthOption ? (
                  <div className="body_font dark_blue">
                    <div className="display-inline flex-align-center margin-bottom-05">
                      <strong style={{ fontWeight: "bold" }}>
                        <span className="body_font dark_blue">{t("available")}:&nbsp;</span>
                      </strong>
                      {
                        data?.clinicTelehealthOption.telehealthOptionText
                        ?.replaceAll(' - No Restrictions', '')
                        ?.replaceAll(' - With Restrictions', '')
                        ?.replaceAll('(phone or video)', '')
                        ?.replaceAll('In-person only', 'No Telehealth Available')
                      }
                    </div>
                    <br />
                    <span className="body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}}>{data?.clinicTelehealthOption
                      .telehealthRestrictionWriteIn ?? ""}</span>
                  </div>
                ) : (
                  <></>
                )}

                {data?.publicTransit ? (
                  <div>
                    <div className="display-inline flex-align-center margin-bottom-05 body_font dark_blue">
                      <strong style={{ fontWeight: "bold" }}>
                        <span className="body_font dark_blue">{t("publicTransit")}:&nbsp;</span>
                      </strong>
                      <span className="body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}}>{data?.publicTransitWriteIn &&
                      data?.publicTransitWriteIn.length > 0
                        ? data?.publicTransitWriteIn
                        : t("yes")}</span>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {data?.transportationAssistance ? (
                  <div>
                    <div className="display-inline flex-align-center margin-bottom-05 body_font dark_blue">
                      <strong style={{ fontWeight: "bold" }}>
                        <span className="body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}}>{t("transportationAssistance")}:&nbsp;</span>
                      </strong>
                      <span className="body_font dark_blue">{data?.transportationInfo &&
                      data?.transportationInfo.length > 0
                        ? data?.transportationInfo
                        : t("yes")}</span>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </Grid>
          </Grid>
        </section>
        <hr className="margin-bottom-3" />
        <Grid row gap>
          <Grid col={12} tablet={{ col: 6 }}>
            <section>
              <h2 className="margin-top-1 body_font dark_blue">
                <span className="body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}}>{t("services")}</span> </h2>
              <span className="body_font dark_blue">{renderServicesProvided()}</span>
            </section>
          </Grid>
          <Grid col={12} tablet={{ col: 6 }}>
            <section>
              <h2 className="margin-top-1 body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}} >{t("clientFocus")}</h2>
              <div>
                <div className="display-flex flex-align-center margin-bottom-05">
                  <Ages className="data-icon width-3 margin-right-1" />
                  <h3 className="margin-0 body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}}>{t("ageGenderIdentity")} </h3>
                </div>
                <BulletedList
                  values={agesGenderIdentities}
                  className="line-height-body-4 margin-left-3"
                  emptyMsg={t("moreInfo")}
                />
              </div>

              <div>
                <div className="display-flex flex-align-center margin-bottom-05 body_font dark_blue">
                  <Populations className="data-icon width-3 margin-right-1" />
                  <h3 className="margin-0 body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}}>{t("ethnicitiesAndComunities")} </h3>
                </div>
                <BulletedList
                  values={populationsServed}
                  className="line-height-body-4 margin-left-3"
                  emptyMsg={t("moreInfo")}
                />
              </div>

              <div>
                <div className="display-flex flex-align-center margin-bottom-05">
                  <Languages className="data-icon width-3 margin-right-1" />
                  <h3 className="margin-0 body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}}>{t("languagesSpoken")} </h3>
                </div>
                <BulletedList
                  values={languages}
                  className="line-height-body-4 margin-left-3"
                  emptyMsg={t("moreInfo")}
                />
              </div>

              <div>
                <div className="display-flex flex-align-center margin-bottom-05">
                  <Accessibility className="data-icon width-3 margin-right-1" />
                  <h3 className="margin-0 body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}}>{t("accessibilityAccess")} </h3>
                </div>
                <BulletedList
                  values={accessibility}
                  className="line-height-body-4 margin-left-3"
                  emptyMsg={t("moreInfo")}
                />
              </div>
            </section>
          </Grid>
        </Grid>
        {data?.updatedAt && (
          <p className="margin-top-2">
            <span className="body_font dark_blue">{t("dataLastUpdated")}: {new Date(data.updatedAt).toString()}</span>
          </p>
        )}
        <Grid>
          <div>
            <ProviderUpdateInfo header={t("bhaProviderUpdateQuestion")} />
          </div>
        </Grid>
        <Grid row>
          <Grid col={12} className="print-hide body_font dark_blue">
            <section className="margin-top-4 margin-bottom-2 body_font dark_blue">
              <Accordion
                bordered
                className="body_font dark_blue"
                items={[
                  {
                    title: <span className="body_font dark_blue">{t("complaintTitle")}</span>,
                    content: (
                      <div className="body_font dark_blue">
                        <p className="body_font dark_blue">
                          <span  className="body_font dark_blue">{t("complaintFormInfo")}</span>
                        </p>
                        <a className="body_font dark_blue" href={t("complaintFormHelpUrl")} rel="noreferrer" target="_blank">{t("complaintFormLinkText")}</a>
                      </div>
                    ),
                    expanded: false,
                    id: "complaint",
                    headingLevel: "h2",
                  },
                ]}
              />
            </section>
          </Grid>
        </Grid>
      </GridContainer>
  </Fragment>
  );
};
export default ResultDetail;
